import { useCallback, useEffect, useState } from 'react';

import useLocalStorage from '@zenbusiness/application-commons-hooks/useLocalStorage';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import { useIntl } from '@zenbusiness/application-commons-intl';
import Snackbar from '@zenbusiness/zui/Snackbar';

import {
  Carousel,
  CarouselSlide,
  ReferAFriendCard,
  SMSOptInCard,
  TaxAdviceCard
} from '#client/components/Carousel';
import { HomeSection } from '#client/components/HomeSection';
import useNotificationPreferences from '#client/hooks/useNotificationPreferences';
import useNotificationPreferencesUpdate from '#client/hooks/useNotificationPreferencesUpdate';

const SMS_OPT_IN_CARD_DISMISSED = 'smsOptInCardDismissed';

export const LOCALIZED_TEXT = {
  optInError: 'dashboard.carousel.card.smsOptIn.snackbar.error'
};

function DashboardCarousel() {
  const { userUuid } = useIdentity();
  const { formatMessage: fm } = useIntl();

  const { notificationPreferences, hasUnknownError } = useNotificationPreferences(userUuid);
  const {
    saveNotificationPreferences,
    loading,
    hasError: optInError
  } = useNotificationPreferencesUpdate(userUuid);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [isCardDismissed, setIsCardDismissed] = useLocalStorage(
    SMS_OPT_IN_CARD_DISMISSED,
    false
  );

  useEffect(() => {
    if (optInError) {
      setShowSnackbar(true);
    }
  }, [optInError]);

  const handleSnackbarOnClose = useCallback(() => {
    setShowSnackbar(false);
  }, []);

  const showSMSCard = !(
    notificationPreferences?.smsOptIn
    || isCardDismissed
    || hasUnknownError
  );

  const totalSlides = showSMSCard ? 3 : 2;

  const carouselEventingProperties = {
    bannerType: 'promo',
    elementName: 'dashboard_carousel',
    elementValue: ['sms_opt_in', 'tax_advice', 'refer_a_friend']
  };

  return (
    <HomeSection>
      <Carousel
        autoplayDurationInSeconds={15}
        totalSlides={totalSlides}
        eventingProperties={carouselEventingProperties}
      >
        {showSMSCard && (
          <CarouselSlide slideIndex={1} totalSlides={totalSlides}>
            <SMSOptInCard
              currentPhoneNumber={notificationPreferences?.smsPhoneNumber}
              handleCardDismissed={setIsCardDismissed}
              handleSaveNotificationPreferences={saveNotificationPreferences}
              isSavingPhoneNumber={loading}
            />
          </CarouselSlide>
        )}
        <CarouselSlide slideIndex={showSMSCard ? 2 : 1} totalSlides={totalSlides}>
          <TaxAdviceCard />
        </CarouselSlide>
        <CarouselSlide slideIndex={showSMSCard ? 3 : 2} totalSlides={totalSlides}>
          <ReferAFriendCard />
        </CarouselSlide>
      </Carousel>
      <Snackbar
        autoHideDuration={5000}
        onClose={handleSnackbarOnClose}
        open={showSnackbar}
        title={fm({ id: LOCALIZED_TEXT.optInError })}
        variant="alert"
      />
    </HomeSection>
  );
}

export default DashboardCarousel;
